import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Injector,
  OnDestroy,
  ViewChild,
  TemplateRef
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
declare var $: any;

import { MenuService } from "../../../core/menu/menu.service";
import { SettingsService } from "../../../core/settings/settings.service";
import { TranslatorService } from "../../../core/translator/translator.service";
import { Location } from "@angular/common";
import { Subject, Subscription } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { StorageService } from "../../../routes/services/storage.service";
import { UsersService } from "../../../routes/services/users.service";

import { GlobalFunction, urlAdmin, urlClient } from "../../../routes/services/globalFuntion";
import { ClientsService } from "../../../routes/services/clients.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ViewportService } from "../../../core/viewport/viewport.service";
import { buildSidebarSections, OTHER_MENU, SidebarSection } from "./sidebar-sections";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild("profile") public profile;

  menuItems: Array<any>;
  /** Menu agrupado por secciones (ver sidebar-sections.ts). */
  sections: SidebarSection[] = [];
  sbclickEvent = "click.sidebar-toggle";
  $doc: any = null;
  link = "";

  user: any;

  configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    size: "md",
    centered: true,
    class: "modal-config pos-modal"
  };

  socketModeSubcription: Subscription | undefined;
  sidebarSectionSubsciption: Subscription | undefined;
  permissionsSuscription: Subscription | undefined;
  cycleSuscription: Subscription | undefined;
  farmSubsciption: Subscription | undefined;

  /** Texto (clave i18n) del item con submenu desplegado; null si ninguno. */
  openSubmenuKey: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private modalService: NgbModal,
    public translator: TranslatorService,
    public settings: SettingsService,
    public location: Location,
    public injector: Injector,
    public menu: MenuService,
    public router: Router,
    public storageService: StorageService,
    public userService: UsersService,
    public globalFunction: GlobalFunction,
    public clientService: ClientsService,
    public viewport: ViewportService,
    private elementRef: ElementRef<HTMLElement>
  ) {
    router.events.subscribe((val) => {
      this.link = location.path();
    });
  }

  /** Cancela suscripciones y listeners del sidebar. */
  ngOnDestroy() {
    if (this.$doc) this.$doc.off(this.sbclickEvent);
    this.socketModeSubcription?.unsubscribe();
    this.sidebarSectionSubsciption?.unsubscribe();
    this.permissionsSuscription?.unsubscribe();
    this.cycleSuscription?.unsubscribe();
    this.farmSubsciption?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.permissionsSuscription = this.storageService
      .watchStorage("permissions")
      .subscribe(() => this.loadMenu());

    this.sidebarSectionSubsciption = this.storageService
      .watchStorage("sidebar_section")
      .subscribe(() => this.loadMenu());

    if (this.storageService.localValue) {
      const personal_web = this.storageService.localValue;
      this.loadMenu();
      let bol = personal_web.hasOwnProperty("isCollapsedText");
      setTimeout(() => {
        const { isCollapsedText } = personal_web;
        this.settings.setLayoutSetting("isCollapsedText", bol ? isCollapsedText : false);
      }, 300);
    }

    this.get_user().then((user) => {
      this.user = user;
    });

    this.router = this.injector.get(Router);

    this.router.events.subscribe((val) => {
      // close any submenu opened when route changes
      this.removeFloatingNav();
      // scroll view to top
      window.scrollTo(0, 0);
    });

    this.socketModeSubcription = this.storageService.watchStorage("mode").subscribe((mode: any) => {
      this.get_user().then((user) => {
        this.user = user;
      });

      this.loadMenu();
    });
    // enable sidebar autoclose from extenal clicks

    // Compacto: el panel se cierra al navegar y al pasar a escritorio
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.closeMobileMenu();
        this.openActiveSubmenu();
      });
    this.viewport.isCompact$
      .pipe(
        filter((isCompact) => !isCompact),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.closeMobileMenu());
  }

  /**
   * Cierra el panel al tocar el fondo oscuro (el propio host fuera de ".aside-inner").
   * @param event evento de click sobre el host.
   */
  @HostListener("click", ["$event"])
  onHostClick(event: MouseEvent): void {
    if (event.target !== this.elementRef.nativeElement) {
      return;
    }
    this.closeMobileMenu();
  }

  /** Cierra el panel con la tecla Escape. */
  @HostListener("document:keydown.escape")
  onEscape(): void {
    this.closeMobileMenu();
  }

  /** Cierra el panel flotante de compacto. */
  closeMobileMenu(): void {
    if (!this.settings.getLayoutSetting("asideMobileOpen")) {
      return;
    }
    this.settings.setLayoutSetting("asideMobileOpen", false);
  }

  /** Agrupa el menu actual (ya filtrado por permisos) en secciones y abre el submenu activo. */
  loadMenu(): void {
    this.menuItems = this.menu.getMenu() || [];
    this.sections = buildSidebarSections([...this.menuItems, ...OTHER_MENU]);
    this.openActiveSubmenu();
  }

  /** Despliega el submenu que contiene la ruta actual; si ninguno la contiene, pliega el abierto. */
  openActiveSubmenu(): void {
    const url = this.router.url.split("?")[0];
    const isActive = (link: string) => !!link && (url === link || url.startsWith(`${link}/`));
    const parent = this.sections
      .reduce((acc, section) => [...acc, ...section.items], [])
      .find((item) => item.submenu && item.submenu.some((subitem) => isActive(subitem.link)));
    this.openSubmenuKey = parent ? parent.text : null;
  }

  /**
   * Indica si una seccion esta plegada.
   * @param key clave i18n de la seccion (null para el grupo sin titulo).
   * @returns true si sus opciones estan ocultas.
   */
  isSectionCollapsed(key: string | null): boolean {
    const collapsed = this.storageService.localValue.sidebar_collapsed_sections || [];
    return !!key && collapsed.includes(key);
  }

  /**
   * Pliega o despliega una seccion y lo guarda en las preferencias del usuario.
   * @param key clave i18n de la seccion.
   */
  toggleSection(key: string): void {
    const local = this.storageService.localValue;
    const collapsed = local.sidebar_collapsed_sections || [];
    const sidebar_collapsed_sections = collapsed.includes(key)
      ? collapsed.filter((section) => section !== key)
      : [...collapsed, key];
    const setLocal = { ...local, sidebar_collapsed_sections };

    this.storageService.localValue = setLocal;
    this.storageService
      .editPreferences(setLocal)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe({ error: () => {} });
  }

  /**
   * Indica si el submenu de un item esta desplegado.
   * @param item item del menu.
   * @returns true si es el submenu abierto.
   */
  isSubmenuOpen(item: any): boolean {
    return !!item.submenu && this.openSubmenuKey === item.text;
  }

  /**
   * Click sobre un item con submenu: despliega/pliega sus opciones debajo (acordeon).
   * Con el menu colapsado solo evita la navegacion, porque el submenu flotante se abre con hover.
   * @param event evento de click.
   * @param item item del menu con submenu.
   */
  onSubmenuClick(event: Event, item: any): void {
    event.preventDefault();
    if (this.isCollapsedText()) {
      return;
    }
    this.openSubmenuKey = this.isSubmenuOpen(item) ? null : item.text;
  }
  submitUser = (user) => {
    if (this.user.is_subclient) {
      this.user.subclient.logo = user.logo;
      this.user.email = user.user.email;
      this.user.first_name = user.user.first_name;
      this.user.last_name = user.user.last_name;
    } else {
      this.user.client.logo = user.logo;
      this.user.email = user.user.email;
      this.user.first_name = user.user.first_name;
      this.user.last_name = user.user.last_name;
    }
  };
  validateImage(user) {
    if (user.is_subclient && user.subclient.logo) {
      return user.subclient.logo;
    }
    if (!user.is_subclient && user.client && user.client.logo) {
      return user.client.logo;
    }
    return "";
  }
  get_user = async () => {
    const local_user = <any>JSON.parse(localStorage.getItem("USER") || "{}");
    const { mode, client } = this.storageService.localValue;

    try {
      if (mode) {
        const resp = await this.clientService.getClient(client.user.client.id).toPromise();
        if (resp) {
          return { ...client.user, client: resp };
        }
      }
      if (local_user) {
        if (local_user.subclient && local_user.subclient.client) {
          const resp = await this.clientService.getClient(local_user.subclient.client).toPromise();
          if (resp) {
            return { ...local_user, client: resp };
          }
        }
        if (local_user.client) {
          const resp = await this.clientService.getClient(local_user.client.id).toPromise();
          if (resp) {
            return { ...local_user, client: resp };
          }
        }
      }
    } catch (error) {
      return local_user;
    }
    return local_user;
  };
  Modal = (template: TemplateRef<any>, type) => {
    switch (type) {
      case "show":
        this.modalService.open(template, this.configModal);
        break;
      case "hide":
        this.modalService.dismissAll();
        break;
      default:
    }
  };

  toggleSubmenuHover(event) {
    let self = this;

    // Flotante solo con el menu colapsado; si no, el submenu es acordeon (ver onSubmenuClick)
    if (!this.isCollapsedText()) {
      return;
    }

    event.preventDefault();
    this.removeFloatingNav();

    let ul = $(event.currentTarget.nextElementSibling);
    let anchor = $(event.currentTarget);
    // Opcion sin submenu: el flotante solo muestra su nombre (etiqueta)
    const isLabel = !ul.length;

    let $aside = $(".aside-container");
    let $asideInner = $aside.children(".aside-inner"); // for top offset calculation
    let $sidebar = $asideInner.children(".sidebar");
    let mar = parseInt($asideInner.css("padding-top"), 0) + parseInt($aside.css("padding-top"), 0);
    let itemTop = anchor.parent().position().top + mar - $sidebar.scrollTop();

    let floatingNav = (isLabel ? this.buildFloatingLabel(anchor) : ul.clone()).appendTo($aside);
    let vwHeight = document.body.clientHeight;

    // let itemTop = anchor.position().top || anchor.offset().top;

    floatingNav
      .removeClass("opening") // necesary for demo if switched between normal//collapsed mode
      .addClass("nav-floating")
      .css({
        position: this.settings.getLayoutSetting("isFixed") ? "fixed" : "absolute",
        top: itemTop,
        bottom: floatingNav.outerHeight(true) + itemTop > vwHeight ? 0 : "auto"
      });

    floatingNav
      .on("mouseleave", () => {
        floatingNav.remove();
      })
      .find("a")
      .on("click", function (e) {
        e.preventDefault(); // prevents page reload on click
        // get the exact route path to navigate
        let routeTo = $(this).attr("route");
        if (routeTo) self.router.navigate([routeTo]);
      });

    // La etiqueta se quita al salir del icono, salvo que el mouse pase a la etiqueta
    if (isLabel) {
      const onLeave = (e: MouseEvent) => {
        const target = e.relatedTarget as HTMLElement | null;
        if (!target || !target.closest(".nav-floating")) {
          floatingNav.remove();
        }
      };
      event.currentTarget.addEventListener("mouseleave", onLeave, { once: true });
    }

    this.listenForExternalClicks();
  }

  /**
   * Crea el flotante de una opcion sin submenu (menu colapsado): una sola fila
   * con su nombre que tambien navega al hacer click.
   * @param anchor enlace (jQuery) de la opcion del menu.
   * @returns lista flotante lista para insertarse en el aside.
   */
  private buildFloatingLabel(anchor: any): any {
    const source: HTMLElement = anchor[0];
    const link = document.createElement("a");
    link.setAttribute("href", "");
    link.setAttribute("route", source.getAttribute("route") || "");
    link.textContent = source.getAttribute("title");

    const item = document.createElement("li");
    item.classList.toggle("active", source.parentElement.classList.contains("active"));
    item.appendChild(link);

    const list = document.createElement("ul");
    list.className = "sidebar-nav sidebar-subnav nav-floating-label";
    list.appendChild(item);
    return $(list);
  }

  /**
   * Indica si el menu muestra solo iconos. En compacto siempre se muestran los textos.
   * @returns true si el menu esta colapsado (solo escritorio).
   */
  isCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText") && !this.viewport.isCompact;
  }
  listenForExternalClicks() {
    let $doc = $(document).on("click.sidebar", (e) => {
      if (!$(e.target).parents(".aside-container").length) {
        this.removeFloatingNav();
        $doc.off("click.sidebar");
      }
    });
  }

  removeFloatingNav() {
    $(".nav-floating").remove();
  }

  isSidebarCollapsed() {
    return this.settings.getLayoutSetting("isCollapsed");
  }
  isSidebarCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText");
  }
  isEnabledHover() {
    return this.settings.getLayoutSetting("asideHover");
  }
  getCurrentQuery() {
    const { mode } = this.storageService.localValue;
    return (mode === 0 || !mode) && this.globalFunction.validateSoloAdmin()
      ? "query_admin"
      : "query_client";
  }
  validateCurrentUrl() {
    const { client, mode } = this.storageService.localValue;
    const validateText = (array, text) => {
      let filter = array.filter((item) => text.indexOf(item) !== -1);
      return filter.length > 0;
    };
    const query = this.storageService.localValue[this.getCurrentQuery()];

    if (query && query.current_url) {
      const current_url = query.current_url || "";
      if (mode === 1 && client) {
        if (validateText(urlClient, current_url)) {
          this.router.navigateByUrl(current_url);
        } else {
          this.router.navigateByUrl(`/dashboard`);
        }
      }
      if ((mode === 0 || !mode) && this.globalFunction.validateSoloAdmin()) {
        if (validateText(urlAdmin, current_url)) {
          this.router.navigateByUrl(current_url);
        } else {
          this.router.navigateByUrl("/home");
        }
      }
    } else {
      if ((mode === 0 || !mode) && this.globalFunction.validateSoloAdmin()) {
        this.router.navigateByUrl("/home");
      } else {
        this.router.navigateByUrl(`/dashboard`);
      }
    }
  }
}
